module.exports = __webpack_public_path__ + "img/house.379d557c.svg";